import { useIdleTimer } from "react-idle-timer";
import { signOut } from '@aws-amplify/auth';
import { SET_ROLES, SET_USER_NAME, UPDATE_LOGGED_IN_USER } from "../../store/reducer/LoggedInUserReducer";
import { useContext, useEffect } from "react";
import { AppContext } from "../../store/AppProvider";
import { xhrCall } from "../../utils/Constants";
import { fetchAuthSession } from 'aws-amplify/auth';
import { getActiveRole } from '../../utils/Utils';

export const IdleTimeTracker = () => {

    const { setName, setRoles, setLoggedInUser, setActiveRole } = useContext(AppContext);

    const setTheExpiryTime = () => {
        var today = new Date();
        today.setHours(today.getHours() + 1);
        sessionStorage.setItem('expiryTime', today);
    }

    if (!sessionStorage.getItem('expiryTime') || ((new Date(sessionStorage.getItem('expiryTime')) - new Date()) <= 0)) {
        setTheExpiryTime();
    }

    const handleLogout = () => {
        signOut().then(() => {
            setLoggedInUser({ type: UPDATE_LOGGED_IN_USER, payload: { loggedIn: false } })
            setName({ type: SET_USER_NAME, payload: { displayName: null, family_name: null, given_name: null } })
            setRoles({ type: SET_ROLES, payload: { roles: [] } })
            setActiveRole('')
            sessionStorage.removeItem('expiryTime');
        })
    }

    const { reset: resetIdleTimer } = useIdleTimer({
        timeout: new Date(sessionStorage.getItem('expiryTime')) - new Date(),
        onIdle: () => handleLogout(),
        debounce: 500,
        events: []
    });


    const handleResetIdleTimer = function (e) {

        // If there was any API call in the last 5 minutes then extend the session and reset the timer.
        if (new Date(sessionStorage.getItem('expiryTime')) - new Date() < 300000) {
            // Refresh the token
            fetchAuthSession({ forceRefresh: true }).then((data) => {
                const payld = data?.tokens?.idToken?.payload
                const displayName = payld?.['custom:displayname'] || `${payld['given_name']} ${payld['family_name']}`
                const roles = payld['custom:accessrole']?.split(",")
                const activeRole = getActiveRole(roles)
                setLoggedInUser({ type: UPDATE_LOGGED_IN_USER, payload: { loggedIn: Boolean(payld['email']) } })
                setName({ type: SET_USER_NAME, payload: { displayName, family_name: payld['family_name'], given_name: payld['given_name'] } })
                setRoles({ type: SET_ROLES, payload: { roles } })
                setActiveRole(activeRole)

                // Set the latest token 
                const keys = Object.keys(sessionStorage);
                for (data in keys) {
                    if (keys[data].includes('.idToken')) {
                        sessionStorage.setItem('idToken', sessionStorage.getItem(keys[data]));
                    }
                }

            }).catch((error) => {
                console.log("Something Went Wrong > ", error)
            })
            // reset the expiry time.
            setTheExpiryTime();
            // reset the IdleTimer.
            resetIdleTimer();
        }

    }

    useEffect(function () {
        window.addEventListener(xhrCall, handleResetIdleTimer);

        return function () { window.removeEventListener(xhrCall, handleResetIdleTimer) }
    });

    return "";
}